// Antigüedad calculada en frontend a partir de fecha_ingreso (M.2B.1).
// No se guarda ni se envía: sólo presentación.
//
// Regla (diferencia de CALENDARIO, no días/365):
//   1. Se toma sólo la parte de fecha (yyyy-MM-dd) del ingreso, sin zona
//      horaria, y "hoy" en la fecha local del teléfono.
//   2. Meses completos: se suman meses a la fecha de ingreso mientras no se
//      pase de hoy. Si el día no existe en el mes destino se usa el último
//      día de ese mes (31-ene + 1 mes = 28-feb; 29-feb-2024 + 12 = 28-feb-2025).
//      Días = días naturales restantes desde esa fecha hasta hoy.
//   3. Expresión humana, sin días cuando ya hay meses o años:
//        ≥ 1 año  -> "N año(s)" o "N año(s) M mes(es)"
//        ≥ 1 mes  -> "M mes(es)"
//        < 1 mes  -> "N día(s)"; mismo día -> "Hoy"
//   4. Fecha faltante, inválida o futura -> null (se omite el dato).

const diasEnMes = (anio, mes) => new Date(anio, mes, 0).getDate(); // mes 1-12

export function parsearFechaIngreso(valor) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor == null ? '' : valor).trim());
  if (!m) return null;
  const anio = Number(m[1]); const mes = Number(m[2]); const dia = Number(m[3]);
  if (mes < 1 || mes > 12 || dia < 1 || dia > diasEnMes(anio, mes)) return null;
  return { anio, mes, dia };
}

function sumarMeses(fecha, n) {
  const total = fecha.mes - 1 + n;
  const anio = fecha.anio + Math.floor(total / 12);
  const mes = ((total % 12) + 12) % 12 + 1;
  return { anio, mes, dia: Math.min(fecha.dia, diasEnMes(anio, mes)) };
}
const numeroDia = f => Date.UTC(f.anio, f.mes - 1, f.dia) / 86400000;

export function diferenciaCalendario(desde, hasta) {
  if (numeroDia(hasta) < numeroDia(desde)) return { anios: -1, meses: 0, dias: 0 };
  let meses = (hasta.anio - desde.anio) * 12 + (hasta.mes - desde.mes);
  if (numeroDia(sumarMeses(desde, meses)) > numeroDia(hasta)) meses -= 1;
  const dias = numeroDia(hasta) - numeroDia(sumarMeses(desde, meses));
  return { anios: Math.floor(meses / 12), meses: meses % 12, dias };
}

const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;

export function calcularAntiguedad(fechaIngreso, hoy = new Date()) {
  const ingreso = parsearFechaIngreso(fechaIngreso);
  if (!ingreso) return null;
  const actual = { anio: hoy.getFullYear(), mes: hoy.getMonth() + 1, dia: hoy.getDate() };
  const { anios, meses, dias } = diferenciaCalendario(ingreso, actual);
  if (anios < 0) return null; // ingreso en el futuro
  if (anios >= 1) return meses > 0 ? `${plural(anios, 'año', 'años')} ${plural(meses, 'mes', 'meses')}` : plural(anios, 'año', 'años');
  if (meses >= 1) return plural(meses, 'mes', 'meses');
  if (dias === 0) return 'Hoy';
  return plural(dias, 'día', 'días');
}
